import api from '../store/axiosConfig';

interface UserStats {
  loginStreak: number;
  totalQuizzesTaken: number;
  totalQuizScore: number;
  averageQuizScore: number;
  bestQuizScore: number;
  worstQuizScore: number;
  collectionsCreated: number;
  flashcardsCreated: number;
  totalStudyTime: number;
  lastStudySession: Date;
  studySessionsCount: number;
  quizzesByDifficulty: {
    easy: number;
    medium: number;
    hard: number;
  };
  lastLoginDate: string;
  lastActivityDate: string;
  quizHistory?: {
    date: string;
    score: number;
  }[];
}

export const statsService = {
  async getUserStats(): Promise<UserStats> {
    const response = await api.get('/stats'); // ✅
    return response.data;
  },

  async updateLoginStreak(): Promise<UserStats> {
    const response = await api.post('/stats/login-streak'); // ✅
    return response.data;
  },

  async updateQuizStats(
    score: number,
    difficulty: 'easy' | 'medium' | 'hard' = 'medium',
    studyTime?: number
  ): Promise<UserStats> {
    const payload = { score, difficulty };
    if (studyTime !== undefined) {
      (payload as any).studyTime = studyTime;
    }

    const response = await api.post('/stats/quiz', payload); // ✅
    return response.data;
  },

  async updateStudySession(duration: number): Promise<UserStats> {
    const response = await api.post('/stats/study-session', { duration }); // ✅
    return response.data;
  },
};
